import { Head, Link, useForm } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import type { FormEvent } from "react"

export default function Login() {
  const { data, setData, post, processing, errors } = useForm({
    email_address: "",
    password: "",
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post("/session")
  }

  return (
    <>
      <Head title="Sign In" />
      <div className="flex min-h-svh items-center justify-center bg-background p-4">
        <Card className="w-full max-w-sm">
          <CardHeader className="text-center">
            <CardTitle className="text-xl">Sign in to Feedwatch</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email_address">Email</Label>
                <Input
                  id="email_address"
                  type="email"
                  value={data.email_address}
                  onChange={(e) => setData("email_address", e.target.value)}
                  placeholder="you@example.com"
                  autoComplete="email"
                  required
                />
                {errors.email_address && (
                  <p className="text-destructive text-sm">{errors.email_address}</p>
                )}
              </div>

              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  type="password"
                  value={data.password}
                  onChange={(e) => setData("password", e.target.value)}
                  autoComplete="current-password"
                  required
                />
                {errors.password && (
                  <p className="text-destructive text-sm">{errors.password}</p>
                )}
              </div>

              <Button type="submit" className="w-full" disabled={processing}>
                {processing ? "Signing in..." : "Sign in"}
              </Button>

            </form>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

Login.layout = (page: React.ReactNode) => page
